import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import request from "../util/request";
import {
    generate_physician_notifications_success,
    generate_physician_notifications_failed,

    fetch_physician_notifications as fetch_physician_notifications_action,
    fetch_physician_notifications_success,
    fetch_physician_notifications_failed,

    update_physician_notification_success,
    update_physician_notification_failed,

    fetch_deallocation_notifications_success,
    fetch_deallocation_notifications_failed,

    fetch_patient_with_last_night_data_success,
    fetch_patient_with_last_night_data_failed,
    fetch_recent_patient_success,
    fetch_recent_patient_failed,
    fetch_no_check_for_long_success,
    fetch_no_check_for_long_failed,
    fetch_widgets_success,
    fetch_widgets_failed
} from "actions/home";

import {
    GENERATE_PHYSICIAN_NOTIFICATIONS,
    FETCH_PHYSICIAN_NOTIFICATIONS,
    UPDATE_PHYSICIAN_NOTIFICATION,
    FETCH_DEALLOCATION_NOTIFICATIONS,
    FETCH_PATIENT_WITH_LAST_NIGHT_DATA,
    FETCH_RECENT_PATIENT_DATA,
    NO_CHECK_FOR_LONG,
    FETCH_WIDGETS,
} from "constants/ActionTypes";

function* fetch_widgets_saga() {
    try {
        const response = yield call(request, {
            path: `/physician/widgets`,
            method: "GET",
        });

        if (response.status === 200) {
            yield put(fetch_widgets_success(response.data));
        } else {
            yield put(fetch_widgets_failed())
        }
    } catch (error) {
        console.error(error);
        yield put(fetch_widgets_failed())
    }
}

const patient_with_last_night_data = async () => (
    await request({
        path: "/physician/last-night-patients",
        method: "GET",
    })
);

function* patient_with_last_night_data_saga(payload) {
    try {
        const response = yield call(patient_with_last_night_data, payload);
        const { data = {} } = response;
        if (response.status === 200) {
            yield put(fetch_patient_with_last_night_data_success(data));
        } else {
            yield put(fetch_patient_with_last_night_data_failed(response.message));
        }
    } catch (error) {
        console.log(error)
    }
}

function* recent_patient_list_saga() {
    try {
        const response = yield call(request, {
            path: "/patient/recent-patient",
        });
        const { data = {} } = response;
        if (response.status === 200) {
            yield put(fetch_recent_patient_success(data));
        } else {
            yield put(fetch_recent_patient_failed(response.message));
        }
    } catch (error) {
        console.error(error)
    }
}

function* no_check_for_long_saga() {
    try {
        const response = yield call(request, {
            path: "/patient/no-check-for-long",
            method: "POST"
        });
        const { data = {} } = response;
        if (response.status === 200) {
            yield put(fetch_no_check_for_long_success(data));
        } else {
            yield put(fetch_no_check_for_long_failed(response.message));
        }
    } catch (error) {
        console.error(error);
    }
}

function* generate_physician_notifications_saga() {
    try {
        const response = yield call(request, {
            path: "/physician/generate-notifications",
            method: "POST"
        });
        if (response.status === 200) {
            yield put(generate_physician_notifications_success(response));
        } else {
            yield put(generate_physician_notifications_failed(response.message));
        }
    } catch (error) {
        console.error(error);
    }
}

function* fetch_physician_notifications_saga() {
    try {
        const response = yield call(request, {
            path: "/physician/get-notifications",
            method: "GET"
        });
        const { data = {} } = response;
        if (response.status === 200) {
            yield put(fetch_physician_notifications_success(data));
        } else {
            yield put(fetch_physician_notifications_failed(response.message));
        }
    } catch (error) {
        console.error(error);
    }
}

function* update_physician_notification_saga({ payload }) {
    try {
        const { id } = payload;

        const response = yield call(request, {
            path: "/physician/update-notification/id=" + id,
            method: "POST"
        });
        const { data = {} } = response;
        if (response.status === 200) {
            yield put(update_physician_notification_success(data));
            yield put(fetch_physician_notifications_action());
        } else {
            yield put(update_physician_notification_failed(response.message));
        }
    } catch (error) {
        console.error(error);
    }
}

function* fetch_deallocation_notifications_saga() {
    try {
        const response = yield call(request, {
            path: "/physician/deallocation-notifications",
            method: "GET"
        });

        if (response.status === 200) {
            yield put(fetch_deallocation_notifications_success(response));
        } else {
            yield put(fetch_deallocation_notifications_failed());
        }
    } catch (error) {
        console.error(error);
    }
}

export function* generate_physician_notifications() {
    yield takeLatest(GENERATE_PHYSICIAN_NOTIFICATIONS, generate_physician_notifications_saga);
}

export function* fetch_physician_notifications() {
    yield takeLatest(FETCH_PHYSICIAN_NOTIFICATIONS, fetch_physician_notifications_saga);
}

export function* update_physician_notification() {
    yield takeLatest(UPDATE_PHYSICIAN_NOTIFICATION, update_physician_notification_saga);
}

export function* fetch_deallocation_notifications() {
    yield takeLatest(FETCH_DEALLOCATION_NOTIFICATIONS, fetch_deallocation_notifications_saga);
}

export function* fetch_widgets() {
    yield takeLatest(FETCH_WIDGETS, fetch_widgets_saga);
}

export function* no_check_for_long() {
    yield takeLatest(NO_CHECK_FOR_LONG, no_check_for_long_saga);
}
export function* fetch_patient_with_last_night_data() {
    yield takeLatest(FETCH_PATIENT_WITH_LAST_NIGHT_DATA, patient_with_last_night_data_saga);
}
export function* fetch_recent_patient() {
    yield takeLatest(FETCH_RECENT_PATIENT_DATA, recent_patient_list_saga);
}
export default function* rootSaga() {
    yield all([
        fork(fetch_patient_with_last_night_data),
        fork(fetch_recent_patient),
        fork(no_check_for_long),
        fork(fetch_widgets),
        fork(generate_physician_notifications),
        fork(fetch_physician_notifications),
        fork(update_physician_notification),
        fork(fetch_deallocation_notifications),
    ]);
}